export const MULTILINE_RESIZE_SX = {
  "& textarea": {
    resize: "vertical",
  },
};
